import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            width: '100%',
            textAlign: 'center',
        },
        tabs: {
            display: {base: 'block', md: 'none'},
        },
        content: {
            maxW: {base: '100%', xl: remCalc(1400)},
            mx: {base: 0, xl: 'auto'},
            pt: {base: remCalc(16), md: remCalc(24)},
            px: {base: remCalc(16), md: remCalc(24), xl: 0},

            '.product-moodboard-swiper.desktop': {
                display: 'flex',
                flexDirection: 'column-reverse',
                gap: {base: remCalc(16), md: remCalc(24)},
            },
            '.swiper-pagination-bullet-active': {
                textTransform: 'uppercase',
                textDecoration: 'underline',
                textUnderlineOffset: remCalc(4),
                color: 'text.primary',
            },
            '.swiper-pagination-bullet': {
                background: 'none',
                width: 'auto',
                height: 'auto',
                margin: `0 ${remCalc(13)}`,
                cursor: 'pointer',
                color: 'text.secondary',
            },

            '.img-container:hover img': {
                transform: 'scale(1.2)',
            },
            '.image-big': {
                maxW: {base: remCalc(311), md: remCalc(250), lg: remCalc(310), xl: remCalc(440)},
                maxH: {base: remCalc(250), md: remCalc(250), lg: remCalc(295), xl: remCalc(440)},
            },
            '.image-medium': {
                maxW: {base: remCalc(130), md: remCalc(130), lg: remCalc(178), xl: remCalc(266)},
                maxH: {base: remCalc(130), md: remCalc(130), lg: remCalc(178), xl: remCalc(266)},
            },
            '.image-small': {
                maxW: {base: remCalc(130), md: remCalc(130), lg: remCalc(110), xl: remCalc(164)},
                maxH: {base: remCalc(130), md: remCalc(130), lg: remCalc(100), xl: remCalc(164)},
            },
        },
        pagination: {
            justifyContent: 'center',
            zIndex: 1,
            display: {base: 'none', md: 'flex'},
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        greybox: {
            overflow: 'hidden',
            bg: 'background.light',
            width: '100%',
            minHeight: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
        },
        imagecontainer: {
            position: 'relative',
            overflow: 'hidden',
        },
        imageoverlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        image: {
            transition: 'transform 0.7s ease-in-out',
        },
        textbox: {
            direction: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        productId: {
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            textTransform: 'uppercase',
            pb: remCalc(4),
        },
        productName: {
            textStyle: 'body-large',
            fontWeight: 'bold',
            pb: remCalc(8),
        },
        price: {
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        omnibus: {
            mt: remCalc(4),
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        omnibusPrice: {
            maxW: '100%',
            mt: remCalc(4),
        },
    },
}
